import translationEN from './en/translation.json';

const resources = {
  en: {
    translation: translationEN,
  },
};

export default resources;
